module.exports = __webpack_public_path__ + "static/media/phone.56916f5b.svg";